import React, { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch} from "react-redux";
import {
  Button,
  Divider,
} from "semantic-ui-react";
import { Radio } from "antd";
import { useNavigate } from "react-router";
import { ObjNotificaciones } from "../../../../config/notificaciones";
import "semantic-ui-css/semantic.min.css";
import "../old.scss";
import { BreadCrumbAdmin } from "../../../../components/Administrador/Breadcrumb/Breadcrumb";
import apiConvocatorias from "../../../../api/Convocatorias/api-convocatorias";
import { edicionConvocatoria } from "../../../../redux/actions/convocatoriaAction";
import { useEncrypt } from "../../../../hooks/useEncrypt";
export const PublicarConvocatoria = () => {
  const dispatch = useDispatch();
  const { decrypt } = useEncrypt();

  const idConvocatoria = decrypt(localStorage.getItem("id_convocatoria"));
  const editar_convocatoria = decrypt(
    localStorage.getItem("editar_convocatoria")
  );
  let editarConvocatoria = false;
  if (editar_convocatoria !== null) {
    editarConvocatoria = Boolean(editar_convocatoria);
  }
  const history = useNavigate();

  useEffect(() => {
    consultarConvocatoria();
  }, [idConvocatoria]);

  const inicialState = {
    numeroLinea: 0,
    nombre: "",
    publico: "",
  };

  const [lineaConvocatoriaState, setLineaConvocatoriaState] =
    useState(inicialState);

  const consultarConvocatoria = async () => {
    if (idConvocatoria !== undefined) {
      const token = localStorage.getItem('token')
      await axios
        .get(
          `${process.env.REACT_APP_SERVER_CONV}convocatorias/${idConvocatoria}`,
          {
            headers: {
              'Authorization': token
            }
          }
        )
        .then(({ data }) => {
          return setLineaConvocatoriaState({
            ...lineaConvocatoriaState,
            nombre: data.data.nombre_convocatoria,
            publico: data.data.publico,
          });
        })
        .catch(function (error) {
          console.error(error);
        });
    }
  };

  const publicarConvocatoria = async () => {
    await apiConvocatorias.cambiarestadoPublicoConvocatorias(
      idConvocatoria,
      lineaConvocatoriaState.publico
    );
    if (editarConvocatoria) {
      await ObjNotificaciones.MSG_SUCCESS(
        "success",
        `Se ha guardado correctamente la convocatoria #${idConvocatoria}`
      );
    }
    if (!editarConvocatoria) {
      await ObjNotificaciones.MSG_SUCCESS(
        "success",
        `Se ha guardado correctamente la convocatoria #${idConvocatoria}`
      );
    }
    dispatch(edicionConvocatoria(false));
    return history("/administrador");
  };

  const handleInputChange = ({ target }) => {
    setLineaConvocatoriaState({
      ...lineaConvocatoriaState,
      [target.name]: target.value,
    });
  };

  const routes = [{ nombre: "Crear convocatoria" }];
  return (
    <>
      <div className="container-fluid2 p-0 background-color-F7FBFF height-100">
        <div className="row">
          <BreadCrumbAdmin routes={routes} />
        </div>

        <div className="row row-shadow" style={{ marginBottom: "6%" }}>
          <div className="col-12">
            <div className="row">
              <div className="col-12 col-md-8 p-0 pb-2">
                <span>Publicar convocatoria</span>
              </div>
              <div className="col-12 col-md-4 pb-2 d-flex justify-content-md-end font-color-B0B0B0 font-size-12px font-family-Montserrat-Regular p-0">
                Código de convocatoria: {idConvocatoria}
              </div>
              <Divider className="no-margin pb-3" />

              <div className="container pt-2 pb-2  background-color-F0F6FB ">
                <div className="row">
                  <div className="col-12 col-md-8">
                    {lineaConvocatoriaState.nombre}
                  </div>
                  <div className="col-6 col-md-4 d-flex justify-content-md-end">
                    <Radio.Group
                      name="publico"
                      value={lineaConvocatoriaState.publico}
                      onChange={handleInputChange}
                    >
                      <Radio value={true}>Sí</Radio>
                      <Radio value={false}>No</Radio>
                    </Radio.Group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row container-sticky-footer">
        <div
          className="col-6"
          style={{ paddingTop: "16px", paddingBottom: "16px" }}
        >
          {/* <Button
            className="button-blanco-radius font-size-12px"
            onClick={() => history("/administrador/documentacionConvocatoria")}
          >
            ATRÁS
          </Button> */}
        </div>
        <div
          className="col-6 justify-content-flex-end"
          style={{ paddingTop: "16px", paddingBottom: "16px" }}
        >
          <Button
            className="button-azul-radius font-size-12px"
            onClick={publicarConvocatoria}
          >
            GUARDAR Y CONTINUAR
          </Button>
        </div>
      </div>
    </>
  );
};
